/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './PageLoadingSpinner.scss';

import { string } from 'prop-types';
import React from 'react';

import { Spinner } from '@trp-beacon-ui-kit/react-communication';

const PageLoadingSpinner = ({
  name,
  override = false,
  bypassLoader = false
}) => {
  const message = override ? name : `Preparing ${name}`;
  return bypassLoader ? null : (
    <div className="page-loading-component-overlay">
      <p data-testid="spinner" className="page-loading-message">
        {message}
      </p>
      <Spinner />
    </div>
  );
};

PageLoadingSpinner.propTypes = {
  name: string.isRequired
};

export default PageLoadingSpinner;
